import React, { useEffect, useState } from "react";
import { toJS } from "mobx";
import { useTranslation } from "react-i18next";
import { ResourceRequester } from "sulu-admin-bundle/services";
import _ from "lodash";
import { Table, Divider } from "sulu-admin-bundle/components";

import styles from "./table-details.module.scss";

const dateOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
};

const dateLocale = "en-GB";

const TableDetails = (props) => {
    const [responseData, setResponseData] = useState([]);
    const [columns, setColumns] = useState(
        props.schemaOptions?.columns?.value.replace(" ", "") || "",
    );

    const { t } = useTranslation();
    const locale = props.router.attributes?.locale || "de";
    const resourceKey = props.schemaOptions?.resourceKey?.value;

    const translationPrefix =
        props.schemaOptions?.translationPrefix?.value + "." || "";

    const valuesProperty =
        props.schemaOptions?.valueFieldName?.value ||
        props.dataPath.replace(/^\/+/g, "");
    const resourceIds = props.data[valuesProperty] || "";

    const statusColumn = props.schemaOptions?.statusColumn?.value || "";

    const dateFields =
        props.schemaOptions?.dateColumns?.value.replace(" ", "").split(",") ||
        "";

    const translatableColumns =
        props.schemaOptions?.translatableColumns?.value
            .replace(" ", "")
            .split(",") || "";

    const statusDisabledValue =
        props.schemaOptions?.statusDisabledValue?.value || null;

    const columnList = columns ? columns.split(",") : [];

    const sortBy = toJS(props.schemaOptions?.sort?.value) || "";

    useEffect(() => {
        if (resourceIds && resourceIds.length > 0) {
            ResourceRequester.getList(resourceKey, {
                ids: resourceIds.join(","),
                locale: locale,
                excludeAllFilters: true,
                flat: true,
                ...(columns ? { fields: columns } : {}),
                ...(sortBy ? { sortBy: sortBy[0].name } : {}),
                ...(sortBy ? { sortOrder: sortBy[0].value } : {}),
            })
                .then((data) => {
                    const list = data._embedded?.[resourceKey] || [];
                    setResponseData(list);
                    if (!columns && data._embedded[resourceKey].length > 0) {
                        setColumns(
                            Object.keys(data._embedded[resourceKey][0]).join(
                                ",",
                            ),
                        );
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, []);

    const getStatusAsBool = (item) => {
        if (_.isEmpty(statusColumn)) {
            return true;
        }

        const statusColumnValue = item[statusColumn];

        if (!_.isEmpty(statusDisabledValue) && !_.isEmpty(statusColumnValue)) {
            return statusDisabledValue !== statusColumnValue;
        }

        return !_.isEmpty(statusColumnValue);
    };

    const formatCellValue = (item, column) => {
        const rawValue = item[column];
        let value = null;

        if (dateFields.includes(column) && rawValue) {
            return new Date(rawValue).toLocaleDateString(
                dateLocale,
                dateOptions,
            );
        }

        /*
        typeof rawValue === "boolean" was omitted as no translation has boole as part of translation,
        except `dhb.cms.ads.desktop`, but it's not used for TableDetails.
         */
        if (translatableColumns.includes(column) && !_.isEmpty(rawValue)) {
            value = t(
                `${translationPrefix}${column}.${rawValue.toLowerCase()}`,
            );
        }

        if (column === statusColumn) {
            return (
                <span
                    style={{
                        color: getStatusAsBool(item) ? "green" : "red",
                    }}
                >
                    {value || rawValue}
                </span>
            );
        }

        if (typeof rawValue === "boolean") {
            return (
                <span
                    style={{
                        color: rawValue ? "green" : "red",
                    }}
                >
                    {value || rawValue}
                </span>
            );
        }

        return value || rawValue || "";
    };

    const noDataText = t(`${translationPrefix}licenses.none`);

    return (
        <section className={styles.section}>
            <Divider> {t(`${translationPrefix}title`)}</Divider>
            <Table skin="light" placeholderText={noDataText}>
                <Table.Header>
                    {columnList?.map((column) => (
                        <Table.HeaderCell
                            key={column}
                            className={styles[column]}
                        >
                            {t(`${translationPrefix}${column}.name`)}
                        </Table.HeaderCell>
                    ))}
                </Table.Header>
                <Table.Body>
                    {responseData?.map((item, index) => {
                        const disabledProperty = !getStatusAsBool(item);

                        return (
                            <Table.Row
                                key={item.id + index}
                                disabled={disabledProperty}
                            >
                                {columnList?.map((column) => {
                                    return (
                                        <Table.Cell
                                            key={column}
                                            className={styles[column]}
                                        >
                                            {formatCellValue(item, column)}
                                        </Table.Cell>
                                    );
                                })}
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
        </section>
    );
};
export default TableDetails;
